
export default {
  queryString (pagination) {
    return Object.keys(pagination).map(function (key) {
      return key + '=' + pagination[key]
    }).join('&')
  }
}
